import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css'; //eslint-disable-line

export default class extends BaseModule {
  init() {
    const slider = this.el.querySelector('[data-slider]');
    const { sliderConfig } = slider.dataset;

    const params = {
      project: {
        modules: [Navigation],
        draggable: true,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
      },
      gutenberg: {
        modules: [Navigation],
        draggable: true,
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 3.5,
            spaceBetween: window.innerWidth * 0.085,
            centeredSlide: true,
          },
        },
      },
    };

    this.swiper = new Swiper(slider, params[sliderConfig]);

    if (sliderConfig === 'project') {
      const pagination = document.querySelectorAll('[data-slider-pagination]');
      const info = document.querySelector('[data-module-project]');
      const texture = document.querySelector('[data-project-texture]');
      const mobileNav = document.querySelector('[data-slider-nav-mobile]');
      const swiperItemsCount = (this.swiper.slides.length - 1).toString().padStart(2, '0');

      this.swiper.on('slideChange', () => {
        const { activeIndex } = this.swiper;
        const activeIndexFormatted = (activeIndex + 1).toString().padStart(2, '0');

        const isEnd = activeIndex >= this.swiper.slides.length - 1;

        if (info) {
          info.classList.toggle('hidden', isEnd);
        }

        if (mobileNav) {
          mobileNav.classList.toggle('hidden', isEnd);
        }

        if (texture) {
          texture.classList.toggle('opacity-0', isEnd);
        }

        pagination.forEach(function(p) {
          p.classList.toggle('hidden', isEnd);
          p.innerHTML = `${activeIndexFormatted} / ${swiperItemsCount}`;
        })
      });

      // Initialize the pagination on load
      const initialIndexFormatted = (this.swiper.activeIndex + 1).toString().padStart(2, '0');
      pagination.innerHTML = `${initialIndexFormatted} / ${swiperItemsCount}`;
    }
  }
}